interface DateRangedItem {
  startDate?: string
  endDate?: string
  [additional: string]: any
}

const sortItemsByDateRange = (items: DateRangedItem[]): DateRangedItem[] => {
  return items.sort((a, b) => {
    const aStart = new Date(a?.startDate || '')
    const bStart = new Date(b?.startDate || '')
    const aEnd = new Date(a?.endDate || '')
    const bEnd = new Date(b?.endDate || '')

    if (!a?.endDate && !b?.endDate) {
      return aStart > bStart ? -1 : 1
    }

    if (!a?.endDate || !b?.endDate) {
      return !a?.endDate ? -1 : 1
    }

    if (a?.endDate === b?.endDate) {
      return aStart > bStart ? -1 : 1
    }

    return aEnd > bEnd ? -1 : 1
  })
}

export default sortItemsByDateRange
